import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';

import Config from '../../config/Config';
import { startAttempt } from '../../redux/testPage/testPage.actions';
import { fetchInstruction } from '../../redux/myCourse/myCourse.actions';
import { getChildReport } from '../../redux/parentDashboard/parentDashboard.actions';
import { setErrorMsg } from '../../redux/utilities/utils.actions';
import pluralise from 'pluralise';

const mapStateToProps = (state) => {
	const {
		courses,
		childrenList,
		childToken,
		productDetail,
	} = state.rootReducer.parentDetails;
	return {
		courses,
		childrenList,
		childToken,
		productDetail,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchInstruction: (elementId, courseId, completed = false, childToken) =>
			dispatch(fetchInstruction({ elementId, courseId, completed, childToken })),
		setErrorMsg: (msg) => dispatch(setErrorMsg(msg)),
		startAttempt: (courseId, elementId) =>
			dispatch(startAttempt({ courseId, elementId })),
		getChildReport: () => dispatch(getChildReport()),
	};
};
const PracticeTest = ({
	match,
	courses,
	childrenList,
	fetchInstruction,
	childToken,
	getChildReport,
	completed,
	total_attempts,
	element_name,
	elementID,
	percentcomplete,
	element_type,
}) => {
	const { course_id } = childrenList[match.params.id || 0];
	const [attemptsAvailable, setAttemptsAvailable] = useState(0);
	useEffect(() => {
		setAttemptsAvailable(total_attempts - completed);
	}, [total_attempts, completed]);
	return (
		<div className="dash-courses last-dash-course">
			<div className="dash-course-logo">
				<img
					src={`${Config.ASSETSPATH}img/STEPATHON_Junior.jpg`}
					alt="courseimage"
				/>
			</div>
			<div className="dash-course-decs">
				<div className="d-flex flex-row align-items-center justify-content-between">
					<div className="flex-grow-1">
						<p className="text-capitalize">{element_name}</p>
						<p className="dash-decs-date">
							<strong>
								{attemptsAvailable > 0
									? `You can attempt the Practice Test ${attemptsAvailable} 
																${pluralise(attemptsAvailable, 'time')}`
									: `No more attempts left.`}
							</strong>
						</p>
						{completed > 0 && completed < total_attempts && (
							<small>
								You have attempted the Practice Test {completed}{' '}
								{pluralise(completed, 'time')}.
							</small>
						)}
						{completed === total_attempts && <small> No more attempts left</small>}
					</div>

					{element_type === 'S' && completed === total_attempts ? (
						<>
							<div className="kid-score-icon">
								<span>{Math.round(courses?.final_score) || 0}%</span>
							</div>
							<div className="kids-certificate" onClick={getChildReport}>
								<img src="/assets/img/chart-download-icon.svg" alt="Test name" />
							</div>{' '}
						</>
					) : (
						<div>
							<button
								onClick={() => {
									percentcomplete === 100
										? fetchInstruction(elementID, course_id, true, childToken)
										: fetchInstruction(elementID, course_id, false, childToken);
								}}
								aria-label="Start Test"
								className={`btn btn-primary step-btn ${
									completed === total_attempts ? 'disabled' : ''
								} `}
							>
								{completed === total_attempts ? 'Review' : 'Practice Now'}
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(PracticeTest),
);
